import React from 'react';
import { AddPageButton } from './AddPage';
import { DeletePageButton } from './DeletePage';
import { DuplicatePageButton } from './DuplicatePage';
export const ManagePagesButtons = () => (React.createElement(React.Fragment, null,
    React.createElement(AddPageButton, null),
    React.createElement(DuplicatePageButton, null),
    React.createElement(DeletePageButton, null)));
